import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import SearchField from 'components/atoms/SearchField'
import DataTable from 'components/organisms/DataTable'
import PaginationControl from 'components/organisms/PaginationControl'

import { manageGroupTrapsColumns } from './'

export const styles = theme => ({
  root: {
    minHeight: 500,
    padding: `${theme.spacing(1)}px 0`,
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  table: {
    margin: `${theme.spacing(6)}px 0`,
  },
})

const ManageGroupTraps = ({
  traps,
  filters,
  classes,
  tableLoading,
  onPageChange,
  onSearchChange,
  onTableSortClick,
  onTableItemSelect,
  onTableSelectableClick,
}) => (
  <div className={classes.root}>
    <div className={classes.header}>
      <Typography variant="h1">Trap details</Typography>
      <SearchField onChange={onSearchChange} />
    </div>
    <DataTable
      key="Manage group trap table"
      dataProvider={traps}
      className={classes.table}
      tableLoading={tableLoading}
      onSortClick={onTableSortClick}
      onItemSelect={onTableItemSelect}
      columns={manageGroupTrapsColumns}
      onSelectableClick={onTableSelectableClick}
      emptyStateTitle="This group has no traps"
      emptyStateDescription="Traps you place and assign to this group will appear here"
    />
    <PaginationControl
      pagination={filters.pagination}
      onPageChange={onPageChange}
    />
  </div>
)

ManageGroupTraps.propTypes = {
  traps: PropTypes.object,
  filters: PropTypes.object,
  classes: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onTableItemSelect: PropTypes.func,
  onTableSelectableClick: PropTypes.func,
}

export default withStyles(styles)(ManageGroupTraps)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupTraps/ManageGroupTraps.js